import { useMutation, useQuery } from 'react-query';
import axios from 'utilities/axios';
import queryClient from 'utilities/queryClient';
import ErrorHandler from 'utilities/errorHandler';
import { messageSuccess } from 'utilities/message';
import { useIntl } from 'react-intl';

const API = {
  GET_PARTNER_PROGRAM: 'partner-program/customers',
  GET_PARTNER_PROGRAM_DISCOUNT_CODE: 'partner-program/discount-codes/my-discount-codes',
  UPDATE_CONGRATULATION: (id) => `partner-program/congratulation/${id}`,
  UPDATE_MORE_INFO_MSC : `partner-program/request-more-info-msc`,
};

export default function usePartnerProgram(options = { enabled: false }) {
  return useQuery(
    'partnerProgram',
    () => options.enabled ? axios.get(API.GET_PARTNER_PROGRAM).then((res) => res.data) : Promise.resolve(null),
    options
  );
}

export const useUpdateShowCongratulation = (showSuccessMsg = true) => {
  return useMutation(({id}) => axios.put(API.UPDATE_CONGRATULATION(id)), {
    onSuccess: (data, values) => {
      queryClient.invalidateQueries('partnerProgram');
    },
  });
};

export const usePartnerProgramDiscountCode = (options = {}) => {
  return useQuery(
    'partnerProgramDiscountCode',
    () => axios.get(API.GET_PARTNER_PROGRAM_DISCOUNT_CODE).then((res) => res.data),
    options
  );
}

export const useRequestMoreInfoOnMSC = () => {
  const intl = useIntl();
  return useMutation(() => axios.put(API.UPDATE_MORE_INFO_MSC), {
    onSuccess: (data, values) => {
      messageSuccess({
        key: 'request-more-info-on-msc',
        content: intl.formatMessage({ id: 'partner_program.request_more_info_success' }),
      });
    },
    onError: (error) => {
      ErrorHandler.showError(error)
    },
  });
};